export function networkErrorMessage(err, fallback = 'Could not reach the interview server.') {
  const msg = String(err?.message || '');
  if (err?.name === 'AbortError' || msg.includes('aborted')) return null;
  if (/failed to fetch|networkerror|load failed|network request failed/i.test(msg)) {
    return 'Could not reach the interview server. Check that the API is running, then refresh and try again.';
  }
  return msg || fallback;
}

export async function readJson(res) {
  return res.json().catch(() => ({}));
}

export function errorFromResponse(data, fallback) {
  const detail = data?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail;
  if (detail && typeof detail === 'object' && detail.message) return detail.message;
  if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
  return fallback;
}

export function isNetworkFailure(err) {
  if (!err) return false;
  if (err.name === 'AbortError') return true;
  const msg = String(err.message || err || '');
  return /failed to fetch|networkerror|load failed|network request failed|abort/i.test(msg);
}

/** CRA overlay treats unhandled fetch rejections as a red screen. Swallow during teardown. */
export function swallowNetworkRejections() {
  const handler = (event) => {
    if (!isNetworkFailure(event.reason)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  };
  window.addEventListener('unhandledrejection', handler, true);
  return () => window.removeEventListener('unhandledrejection', handler, true);
}

export async function safeFetch(url, options) {
  try {
    return await fetch(url, options);
  } catch (err) {
    if (isNetworkFailure(err)) return null;
    throw err;
  }
}
